import useLogoutMutation from '@/api/mutations/auth/useLogout';
import * as authActions from '@payaca/store/auth/authActions';
import { useDispatch } from 'react-redux';
import { useIntercom } from 'react-use-intercom';

const useLogout = () => {
  const dispatch = useDispatch();
  const { mutateAsync: logoutMutation } = useLogoutMutation();
  const { shutdown } = useIntercom();

  return () => {
    // oxlint-disable-next-line typescript-eslint(no-floating-promises) -- FIXME: pre-existing error: Promises must be awaited.
    logoutMutation().finally(() => {
      shutdown();
      dispatch(authActions.logout());
    });
  };
};

export default useLogout;
